import {
  BrowserModule
} from '@angular/platform-browser'
import { NgModule } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module'
import { AppCommonModule } from './common/common.module'
import { AppComponent } from './app.component'
import { MaterialModule } from './modules/material.module'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { TokenInterceptor } from './core/interceptors/token.interceptor'
import { CoreModule } from './core/core.module'
import { RouteUtilService } from './shared/utils/route-util.service'
import { HeaderComponent } from './common/header/header.component'
import { MainComponent } from './common/main/main.component'
import { NavigationComponent } from './common/navigation/navigation.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { SharedModule } from './shared/modules/shared.module'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatCardModule } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { NgSelectModule } from '@ng-select/ng-select'
import { DatepickerComponent } from './shared/directives/datepicker/datepicker.component'
import { CommonModule, DatePipe } from '@angular/common'
import { TimepickerComponent } from './shared/directives/timepicker/timepicker.component'
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { RouterModule } from '@angular/router';
import { OverlayModule, Overlay } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MAT_DIALOG_SCROLL_STRATEGY } from '@angular/material/dialog';
import { ViewportRuler } from '@angular/cdk/scrolling';

export function scrollStrategyFactory(overlay: Overlay) {
  return () => overlay.scrollStrategies.block();
}
@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        NavigationComponent,
        MainComponent,
        DatepickerComponent,
    ],
    exports: [HeaderComponent, MainComponent, NavigationComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AppCommonModule,
        CoreModule.forRoot(),
        MaterialModule,
        FontAwesomeModule,
        CoreModule,
        ToastrModule.forRoot(),
        MatAutocompleteModule,
        SharedModule,
        MatInputModule,
        MatSelectModule,
        MatCardModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        NgSelectModule,
        NgMultiSelectDropDownModule.forRoot(),
        CommonModule,
        RouterModule,
    OverlayModule,
    PortalModule,
        NgProgressModule.withConfig({
            color: "#0b50cede"
        }),
        NgProgressHttpModule], providers: [
        { provide: 'windowObject', useValue: window },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        {
            provide: MatDialogRef,
            useValue: {},
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: scrollStrategyFactory,
      deps: [Overlay]
    },
        // {
        //   provide: HTTP_INTERCEPTORS,
        //   useClass: ErrorInterceptor,
        //   multi: true,
        // },
        ToastrService,
        RouteUtilService,
        DatePipe,
    ViewportRuler,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}


